import { render } from "./MigracionLocacion.vue?vue&type=template&id=6cc61ce2"
import script from "./MigracionLocacion.vue?vue&type=script&lang=js"
export * from "./MigracionLocacion.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__